// src/pages/SellCar/SellCarLanding.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from '../../components/SellCar/styles/SellCarLanding.module.css';
import signupImage from '../../assets/signup.jpg';

const SellCarLanding = () => {
  const navigate = useNavigate();

  const cities = [
    { name: 'Indore', slug: 'indore' },
    { name: 'Dewas', slug: 'dewas' },
    { name: 'Ujjain', slug: 'ujjain' },
    { name: 'Mhow', slug: 'mhow' },
    { name: 'Pithampur', slug: 'pithampur' }
    // { name: 'Jaipur', slug: 'jaipur' },
    // { name: 'Ahmedabad', slug: 'ahmedabad' },
    // { name: 'Chennai', slug: 'chennai' },
    // { name: 'Gurgaon', slug: 'gurgaon' },
    // { name: 'Kolkata', slug: 'kolkata' },
    // { name: 'Noida', slug: 'noida' },
    // { name: 'Lucknow', slug: 'lucknow' }
  ];

    const handleCityClick = (slug) => {
      navigate(`/sell-car/${slug}/journey`);
    };

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <h1 className={styles.title}>Sell Your Car Online</h1>
        <p className={styles.subtitle}>
          Get the best price with instant quotes and free inspection
        </p>
      </div>

      {/* Main Content */}
      <div className={styles.content}>
        {/* Hero Section */}
        <section className={styles.heroSection}>
          <div className={styles.heroContent}>
            <h2>Sell Car Online in Your City</h2>
            <p>Choose your location to get started</p>
          </div>
         <img 
            src={signupImage}
            alt="Sell Your Car"
            className={styles.heroImage}
            onError={(e) => { e.target.style.backgroundColor = '#e0e0e0'; }}
            />
        </section>

        {/* Cities Grid */}
        <section className={styles.citiesSection}>
          <h3 className={styles.sectionTitle}>Select Your City</h3>
          <div className={styles.citiesGrid}>
            {cities.map((city) => (
              <button
                key={city.slug}
                onClick={() => handleCityClick(city.slug)}
                className={styles.cityCard}
              >
                <span className={styles.cityName}>{city.name}</span>
                <span className={styles.arrow}>→</span>
              </button>
            ))}
          </div>
        </section>

        {/* Features Section */}
        <section className={styles.featuresSection}>
          <h3 className={styles.sectionTitle}>Why Sell with Us?</h3>
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>📊</div>
              <h4>Instant Valuation</h4>
              <p>Get an online car valuation instantly based on real-time market trends</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>🔍</div>
              <h4>Car Inspection</h4>
              <p>Complete car inspection at your location or our branch</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>💳</div>
              <h4>Instant Payment</h4>
              <p>Get paid immediately after inspection with bank transfer</p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>📋</div>
              <h4>Zero Documentation Hassle</h4>
              <p>We handle all RC transfer and documentation for you</p>
            </div>
          </div>
        </section>

        {/* Process Steps */}
        <section className={styles.processSection}>
          <h3 className={styles.sectionTitle}>How It Works</h3>
          <div className={styles.stepsContainer}>
            <div className={styles.step}>
              <div className={styles.stepNumber}>1</div>
              <h4>Share Car Details</h4>
              <p>Tell us about your car and upload photos</p>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>2</div>
              <h4>Schedule Inspection</h4>
              <p>Choose date and time for inspection</p>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>3</div>
              <h4>Get Instant Quote</h4>
              <p>Receive final offer immediately after inspection</p>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>4</div>
              <h4>Get Paid & Close Deal</h4>
              <p>Accept offer and get paid instantly</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SellCarLanding;